/*
 * Print247 product form: custom dropdowns, live total, add-ons, size grid,
 * artwork upload and add to cart / buy now / sample pack.
 */
(function () {
  'use strict';

  /* ---------- money ---------- */
  function group(n, places, thousands, decimal) {
    var parts = n.toFixed(places).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts.join(decimal);
  }
  function money(cents, format) {
    var v = cents / 100;
    return (format || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return group(v, 0, ',', '.');
        case 'amount_with_comma_separator': return group(v, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(v, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(v, 2, "'", '.');
        default: return group(v, 2, ',', '.');
      }
    });
  }
  // Per-unit prices can be fractions of a cent ($0.021), so show 3 decimals below 10¢
  function unitMoney(cents, format) {
    if (cents >= 10) return money(Math.round(cents), format);
    return (format || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (cents / 100).toFixed(3));
  }

  /* ---------- custom dropdown ---------- */
  function initDropdown(dd) {
    var btn = dd.querySelector('.p247-dd__btn');
    var list = dd.querySelector('.p247-dd__list');
    var valueEl = dd.querySelector('.p247-dd__value');
    var input = dd.querySelector('input[type="hidden"]');
    var options = Array.prototype.slice.call(list.querySelectorAll('[role="option"]'));
    if (!options.length) { dd.closest('.p247-field').hidden = true; return; }

    function selected() {
      return list.querySelector('[aria-selected="true"]') || options[0];
    }
    function render() {
      var opt = selected();
      valueEl.innerHTML = opt.innerHTML;
      if (input) input.value = opt.getAttribute('data-value');
    }
    function open() {
      list.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      dd.classList.add('is-open');
      selected().focus();
    }
    function close(focusBtn) {
      list.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      dd.classList.remove('is-open');
      if (focusBtn) btn.focus();
    }
    function choose(opt) {
      if (opt.getAttribute('aria-disabled') === 'true') return;
      options.forEach(function (o) { o.setAttribute('aria-selected', o === opt ? 'true' : 'false'); });
      render();
      close(true);
      dd.dispatchEvent(new CustomEvent('p247:change', { bubbles: true }));
    }

    btn.addEventListener('click', function () { list.hidden ? open() : close(); });
    options.forEach(function (o) {
      o.addEventListener('click', function () { choose(o); });
    });
    list.addEventListener('keydown', function (e) {
      var i = options.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); options[Math.min(i + 1, options.length - 1)].focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); options[Math.max(i - 1, 0)].focus(); }
      else if (e.key === 'Home') { e.preventDefault(); options[0].focus(); }
      else if (e.key === 'End') { e.preventDefault(); options[options.length - 1].focus(); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (i > -1) choose(options[i]); }
      else if (e.key === 'Escape' || e.key === 'Tab') { close(e.key === 'Escape'); }
    });
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); open(); }
    });
    document.addEventListener('click', function (e) {
      if (!dd.contains(e.target) && !list.hidden) close();
    });
    render();
  }

  /* ---------- form ---------- */
  function initForm(form) {
    var fmt = form.getAttribute('data-money-format');
    var mode = form.getAttribute('data-qty-mode');
    var baseVariant = parseInt(form.getAttribute('data-variant-id'), 10);
    var unitPrice = parseInt(form.getAttribute('data-unit-price'), 10) || 0;
    var errEl = form.querySelector('[data-p247-error]');
    var totalEl = form.querySelector('[data-p247-total]');
    var unitEl = form.querySelector('[data-p247-unit]');
    var qtyField = form.querySelector('[data-p247-quantity]');
    var sizeInputs = Array.prototype.slice.call(form.querySelectorAll('[data-p247-size]'));
    var addonEls = Array.prototype.slice.call(form.querySelectorAll('[data-p247-addon]'));
    var buttons = Array.prototype.slice.call(form.querySelectorAll('.p247-btn'));
    var artwork = form.querySelector('[data-p247-artwork]');

    form.querySelectorAll('[data-p247-dd]').forEach(initDropdown);

    function state() {
      var s = { variantId: baseVariant, lineQty: 1, units: null, total: unitPrice };
      var opt = qtyField && qtyField.querySelector('[aria-selected="true"]');
      if (opt) {
        s.units = parseInt(opt.getAttribute('data-qty'), 10) || 1;
        if (mode === 'variants') {
          s.variantId = parseInt(opt.getAttribute('data-variant-id'), 10);
          s.total = parseInt(opt.getAttribute('data-price'), 10) || 0;
        } else {
          s.lineQty = s.units;
          s.total = unitPrice * s.units;
        }
      } else if (sizeInputs.length) {
        s.units = sizeInputs.reduce(function (t, el) { return t + Math.max(0, parseInt(el.value, 10) || 0); }, 0);
        s.lineQty = s.units;
        s.total = unitPrice * s.units;
      }
      s.addons = addonEls.filter(function (c) { return c.checked; }).map(function (c) {
        var perUnit = c.getAttribute('data-charge') === 'unit';
        var q = perUnit ? Math.max(1, s.units || 1) : 1;
        return { id: parseInt(c.value, 10), quantity: q, price: (parseInt(c.getAttribute('data-price'), 10) || 0) * q };
      });
      s.addons.forEach(function (a) { s.total += a.price; });
      return s;
    }

    function update() {
      var s = state();
      totalEl.textContent = money(s.total, fmt);
      if (s.units) {
        unitEl.textContent = unitMoney(s.total / s.units, fmt) + ' each / ' + s.units.toLocaleString() + ' units';
      } else if (sizeInputs.length) {
        unitEl.textContent = unitMoney(unitPrice, fmt) + ' each · enter quantities per size';
      } else {
        unitEl.textContent = '';
      }
    }

    /* clear-all buttons (image finishes, add-ons) */
    form.querySelectorAll('[data-p247-clear]').forEach(function (b) {
      b.addEventListener('click', function () {
        b.closest('[data-p247-clear-group]').querySelectorAll('input').forEach(function (i) { i.checked = false; });
        update();
      });
    });

    /* swatch name next to the label */
    form.querySelectorAll('[data-p247-swatch-name]').forEach(function (nameEl) {
      var field = nameEl.closest('.p247-field');
      function show() {
        var c = field.querySelector('input:checked');
        nameEl.textContent = c ? '· ' + c.value : '';
      }
      field.addEventListener('change', show);
      show();
    });

    /* artwork: upload box only when "Yes"; several files can be added one after another */
    var MAX_FILES = 10;
    var MAX_BYTES = 20 * 1024 * 1024;
    var artFiles = [];
    var fileList = artwork ? artwork.querySelector('[data-p247-file-list]') : null;
    function fileKey(f) { return f.name + '|' + f.size + '|' + f.lastModified; }
    if (artwork) {
      var yes = artwork.querySelector('[data-p247-artwork-yes]');
      var upload = artwork.querySelector('[data-p247-upload]');
      var file = artwork.querySelector('[data-p247-file]');
      var fileName = artwork.querySelector('[data-p247-file-name]');
      var defaultName = fileName.textContent;
      var syncInput = function () {
        if (typeof DataTransfer === 'undefined') return;
        var dt = new DataTransfer();
        artFiles.forEach(function (f) { dt.items.add(f); });
        file.files = dt.files;
      };
      var renderFiles = function () {
        fileName.textContent = !artFiles.length ? defaultName
          : artFiles.length === 1 ? artFiles[0].name
          : artFiles.length + ' files selected';
        upload.classList.toggle('has-file', artFiles.length > 0);
        if (!fileList) return;
        fileList.innerHTML = '';
        fileList.hidden = !artFiles.length;
        artFiles.forEach(function (f, i) {
          var li = document.createElement('li');
          var name = document.createElement('span');
          name.className = 'p247-upload-list__name';
          name.textContent = f.name;
          var size = document.createElement('span');
          size.className = 'p247-upload-list__size';
          size.textContent = f.size >= 1048576 ? (f.size / 1048576).toFixed(1) + ' MB' : Math.max(1, Math.round(f.size / 1024)) + ' KB';
          var rm = document.createElement('button');
          rm.type = 'button';
          rm.className = 'p247-upload-list__remove';
          rm.setAttribute('aria-label', 'Remove ' + f.name);
          rm.innerHTML = '&times;';
          rm.addEventListener('click', function () { artFiles.splice(i, 1); syncInput(); renderFiles(); });
          li.appendChild(name); li.appendChild(size); li.appendChild(rm);
          fileList.appendChild(li);
        });
      };
      var syncArtwork = function () {
        upload.hidden = !yes.checked;
        if (!yes.checked) { artFiles = []; file.value = ''; renderFiles(); }
      };
      artwork.addEventListener('change', function (e) { if (e.target !== file) syncArtwork(); });
      file.addEventListener('change', function () {
        var picked = Array.prototype.slice.call(file.files);
        var problems = [];
        picked.forEach(function (f) {
          if (f.size > MAX_BYTES) { problems.push(f.name + ' is over 20 MB'); return; }
          if (artFiles.some(function (x) { return fileKey(x) === fileKey(f); })) return;
          if (artFiles.length >= MAX_FILES) { problems.indexOf('max') < 0 && problems.push('max'); return; }
          artFiles.push(f);
        });
        syncInput();
        renderFiles();
        problems = problems.map(function (p) { return p === 'max' ? 'You can upload up to ' + MAX_FILES + ' files' : p; });
        if (problems.length) showError(problems.join('. ') + '. You can also choose "No, I\'ll share later" and email large files to us.');
        else errEl.hidden = true;
      });
      syncArtwork();
    }

    form.addEventListener('p247:change', update);
    form.addEventListener('change', update);
    form.addEventListener('input', function (e) { if (e.target.hasAttribute('data-p247-size')) update(); });

    /* ---------- cart ---------- */
    function setBusy(on) { buttons.forEach(function (b) { b.classList.toggle('is-busy', on); }); }
    function showError(msg) {
      errEl.textContent = msg;
      errEl.hidden = false;
      setBusy(false);
    }
    function validate(s) {
      errEl.hidden = true;
      if (sizeInputs.length && !s.units) {
        showError('Enter a quantity for at least one size.');
        sizeInputs[0].focus();
        return false;
      }
      if (artwork) {
        var yes = artwork.querySelector('[data-p247-artwork-yes]');
        var file = artwork.querySelector('[data-p247-file]');
        if (yes.checked && !artFiles.length) {
          showError('Please upload your artwork, or choose "No, I\'ll share later".');
          artwork.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return false;
        }
      }
      return true;
    }
    function lineData(s) {
      var fd = new FormData();
      fd.append('id', s.variantId);
      fd.append('quantity', s.lineQty);
      var fields = form.querySelectorAll('[name^="properties["]');
      Array.prototype.forEach.call(fields, function (el) {
        if (el.disabled) return;
        if ((el.type === 'radio' || el.type === 'checkbox') && !el.checked) return;
        if (el.type === 'file') {
          if (artFiles.length) fd.append('properties[Artwork files]', artFiles.map(function (f) { return f.name; }).join(', '));
          return;
        }
        if (el.value === '' || (el.hasAttribute('data-p247-size') && !(parseInt(el.value, 10) > 0))) return;
        fd.append(el.name, el.value);
      });
      if (mode === 'variants' && s.units) fd.append('properties[Quantity]', s.units);
      s.addons.forEach(function (a) {
        var el = form.querySelector('[data-p247-addon][value="' + a.id + '"]');
        if (el) fd.append('properties[Add-on: ' + el.getAttribute('data-name') + ']', 'Yes');
      });
      return fd;
    }
    function request(body, isJson) {
      return fetch(form.getAttribute('data-add-url'), {
        method: 'POST',
        headers: isJson ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
        body: isJson ? JSON.stringify(body) : body
      }).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart.');
          return j;
        });
      });
    }
    function add(dest) {
      var s = state();
      if (!validate(s)) return;
      setBusy(true);
      var title = form.getAttribute('data-product-title');
      var endpoint = window.P247_UPLOAD_URL;
      var uploaded = Promise.resolve([]);
      if (artFiles.length && endpoint) {
        uploaded = Promise.all(artFiles.map(function (f) {
          var up = new FormData();
          up.append('file', f);
          return fetch(endpoint, { method: 'POST', body: up })
            .then(function (r) { if (!r.ok) throw new Error('Artwork upload failed. Please try again.'); return r.json(); })
            .then(function (j) { return j.url || j.link || null; });
        }));
      }
      uploaded
        .then(function (links) {
          var fd = lineData(s);
          links = links.filter(Boolean);
          if (links.length) fd.append('properties[Artwork links]', links.join('\n'));
          return request(fd, false);
        })
        .then(function () {
          if (!s.addons.length) return null;
          return request({
            items: s.addons.map(function (a) { return { id: a.id, quantity: a.quantity, properties: { For: title } }; })
          }, true);
        })
        .then(function () { window.location.href = dest; })
        .catch(function (e) { showError(e.message || 'Something went wrong. Please try again.'); });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      add(form.getAttribute('data-cart-url'));
    });
    var buyNow = form.querySelector('[data-p247-buynow]');
    if (buyNow) buyNow.addEventListener('click', function () { add('/checkout'); });
    var sample = form.querySelector('[data-p247-sample]');
    if (sample) sample.addEventListener('click', function () {
      setBusy(true);
      request({ items: [{ id: parseInt(sample.getAttribute('data-p247-sample'), 10), quantity: 1 }] }, true)
        .then(function () { window.location.href = form.getAttribute('data-cart-url'); })
        .catch(function (e) { showError(e.message); });
    });

    update();
  }

  /* ---------- gallery + accordions ---------- */
  function initGallery(g) {
    var track = g.querySelector('[data-p247-track]');
    var prev = g.querySelector('[data-p247-prev]');
    var next = g.querySelector('[data-p247-next]');
    var bar = g.querySelector('[data-p247-progress]');
    var slides = track ? track.children : [];
    var count = slides.length;
    var i = 0;
    var single = count <= 1;
    /* one image (or none): no arrows, no progress bar, no swiping */
    [prev, next, bar].forEach(function (el) { if (el) el.hidden = single; });
    g.classList.toggle('is-single', single);
    if (single) return;

    function go(n) {
      i = (n + count) % count;
      track.style.transform = 'translateX(-' + i * 100 + '%)';
      if (bar) bar.style.setProperty('--p247-progress', ((i + 1) / count) * 100 + '%');
    }
    prev.addEventListener('click', function () { go(i - 1); });
    next.addEventListener('click', function () { go(i + 1); });

    /* swipe on touch screens */
    var x0 = null, y0 = null;
    g.addEventListener('touchstart', function (e) {
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    g.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? i + 1 : i - 1);
    }, { passive: true });

    /* arrow keys while the gallery has focus */
    g.setAttribute('tabindex', '0');
    g.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(i - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(i + 1); }
    });
    go(0);
  }

  function boot() {
    document.querySelectorAll('[data-p247-form]').forEach(initForm);
    document.querySelectorAll('[data-p247-gallery]').forEach(initGallery);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
